// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.checkbox:hover input ~ .checkmark {
  background-color: #ebebec;
}
.checkbox.opacity-50:hover input ~ .checkmark {
  background-color: #fafafa !important;
}
.checkbox input:checked ~ .checkmark {
  background-color: rgb(var(--color-primary));
}
.checkbox:after {
  content: "";
  position: absolute;
  display: none;
}
.checkbox input:checked ~ .checkmark:after {
  display: block;
}
.checkbox .checkmark:after {
  left: 6px;
  top: 4px;
  width: 6px;
  height: 10px;
  border: solid white;
  border-radius: 2px;
  border-width: 0 3px 3px 0;
  transform: rotate(45deg);
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
